import { createContext, useContext } from 'react';

import type { Breakpoint } from './useContainerSize';

/** The AppShell's measured container breakpoint — the same value that reflows
 *  its chrome (sidebar, TopBar search box), so page content that pairs with
 *  that chrome switches at exactly the same width. */
export const ShellBreakpointContext = createContext<Breakpoint | null>(null);

export function useShellBreakpoint(): Breakpoint {
  const bp = useContext(ShellBreakpointContext);
  if (bp === null) {
    throw new Error('useShellBreakpoint must be used inside <AppShell>.');
  }
  return bp;
}
